/**
 * terra-qyt.17 — the purple-accent token remap for the full-width "Generate
 * with AI" button in `SequenceEditorShell` (Decision 12: generation is the
 * first visible action, so this button gets Clay's purple treatment instead
 * of a plain `secondary` button).
 *
 * DOM-free by design (naming convention, `mini-apps/playbooks/drawer-store.ts`'s
 * `PUSH_DRAWER_*` constants): no React, no Tailwind class list beyond the
 * literal string, so `ai-accent.test.ts` can assert its contents without a
 * render harness (`bun test --isolate` has no `document` global under
 * `mini-apps/`).
 *
 * Glaze's `Button variant="primary"` sets `--btn-bg` / `--btn-hover-bg` FROM
 * `--color-bg-action-inverse` / `--color-bg-action-inverse-hover`
 * (`@clay-run/glaze/src/button.tsx:53-55`). Remapping `--btn-bg` directly on a
 * wrapper would be overridden by the button's own later declaration; instead
 * this remaps the UPSTREAM tokens the button reads from — the same
 * scoped-remap idiom already in-repo at `SegmentationConditionsEditor.tsx:159`
 * and `AudienceRulesStep.tsx:132-134`.
 *
 * Semantic tokens, never hex/rgb, never a raw Tailwind palette class:
 * `--color-bg-purple-active` (`web/app-home/src/index.css:761` light /
 * `:1041` dark), `--color-bg-purple-hover` (`:303` / `:1042`).
 */
export const GENERATE_AI_BUTTON_WRAPPER_CLASS =
  '[--color-bg-action-inverse:var(--color-bg-purple-active)] [--color-bg-action-inverse-hover:var(--color-bg-purple-hover)]';
